<div class="connector" [class.linked]="linked">
  <span class="material-symbols-rounded">{{ linked ? on : off }}</span>
</div>